import { breakpoints } from '../config/Global';
//Hero functions
export default class Hero {
    body;
    hero;
    heroImg;
    breakpoint;
    heroContentHeight;
    constructor(resizeService) {
        this.body = document.querySelector('body');
        this.hero = this.body.querySelector('.js-hero');
        if (!this.hero)
            return;
        resizeService.watch().subscribe(() => {
            this.heroFunc(this.hero);
        });
        this.heroFunc(this.hero);
    }
    heroFunc(hero) {
        this.heroImg = hero.querySelector('.js-hero-image');
        this.breakpoint = window.matchMedia(breakpoints.lg);
        if (this.breakpoint.matches) {
            Object.assign(this.heroImg.style, {
                minHeight: `auto`,
            });
            return;
        }
        this.heroContentHeight = hero.querySelector('.js-hero-content').offsetHeight;
        Object.assign(this.heroImg.style, {
            minHeight: `${this.heroContentHeight + 230}px`,
        });
    }
}
